import * as React from 'react';
import { Spinner } from '@/components/ui/spinner';

import classNames from 'classnames';

type Props = {
  className?: string;
};

const WidgetSpinner: React.FC<React.PropsWithChildren<Props>> = ({
  className = '',
}) => {
  return (
    <div className={classNames('w-100 text-center', className)}>
      <Spinner animation="border" size="sm" />
    </div>
  );
};

export default WidgetSpinner;
